import { render, staticRenderFns } from "./InfosetExportIframeModal.vue?vue&type=template&id=0060f244&scoped=true&"
import script from "./InfosetExportIframeModal.vue?vue&type=script&lang=ts&"
export * from "./InfosetExportIframeModal.vue?vue&type=script&lang=ts&"
import style0 from "./InfosetExportIframeModal.vue?vue&type=style&index=0&id=0060f244&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0060f244",
  null
  
)

export default component.exports